<template>
  <div id="account">
    <div>
      <!-- <h1 v-if="infos">Olá, {{infos.cliente.nome}}!</h1> -->
    </div>

    <div id="sections_account">
      <section id="account_options">
        <ul id="account_options_names" class="op1">
          <!-- <div class="box"/>
          <h1>{{infos.cliente.nome}}</h1> -->
          <button type="button" v-on:click="seeView('Pedidos')">
            <span class="material-icons">reorder</span>
            <li id="options">Meus pedidos</li>
          </button>
          <button type="button" v-on:click="seeView('Endereços')">
            <span class="material-icons">home</span>
            <li id="options">Endereços</li>
          </button>
          <button v-on:click="seeView('Cadastro')">
            <span class="material-icons">person</span>
            <li id="options">Cadastro</li>
          </button>
          <button type="button" v-on:click="logOut()">
            <span class="material-icons">exit_to_app</span>
            <li id="options">Sair</li>
          </button>
        </ul>
        <div class="op2">
          <div id="cadastro_info" v-if="tela === 'Pedidos'">
            <h3>Pedidos</h3>
            <div v-if="pedidos">
              <div v-for="ped in pedidos" :key="ped._id">
                <Pedidos :item="ped" />
              </div>
            </div>
            <div v-else>
              <p>Você ainda não realizou nenhum pedido!</p>
            </div>
          </div>
          <div id="cadastro_info" v-if="tela === 'Endereços'">
            <h3>Endereços</h3>
            <Enderecos :enderecos="enderecos" />
            <button
              type="button"
              id="btn_insert"
              v-on:click="seeView('CadastrarAddress')"
              :updateArray="updateArray"
            >
              Novo
            </button>
          </div>
          <div id="cadastro_info" v-if="tela === 'Cadastro'">
            <h3>Cadastro</h3>

            <div class="address-new">
              <div class="input-address">
                <div class="duple-input">
                  <div class="unique-input">
                    <p>Nome*</p>
                    <input
                      type="name"
                      @change="atualizarCadastroInfo.nome_error = ''"
                      placeholder="Nome"
                      v-model="info.nome"
                    />
                    <p
                      v-if="atualizarCadastroInfo.nome_error != ''"
                      class="error"
                    >
                      {{ atualizarCadastroInfo.nome_error }}
                    </p>
                  </div>
                  <div class="unique-input">
                    <p>Sobrenome*</p>
                    <input
                      @change="atualizarCadastroInfo.sobrenome_error = ''"
                      type="message"
                      placeholder="Sobrenome"
                      v-model="info.sobrenome"
                    />
                    <p
                      v-if="atualizarCadastroInfo.sobrenome_error != ''"
                      class="error"
                    >
                      {{ atualizarCadastroInfo.sobrenome_error }}
                    </p>
                  </div>
                </div>
                <div class="duple-input">
                  <div class="unique-input">
                    <p>Email*</p>
                    <input
                      type="message"
                      @change="atualizarCadastroInfo.email_error = ''"
                      placeholder="E-mail"
                      v-model="info.email"
                    />
                    <p
                      v-if="atualizarCadastroInfo.email_error != ''"
                      class="error"
                    >
                      {{ atualizarCadastroInfo.email_error }}
                    </p>
                  </div>
                  <div class="unique-input">
                    <p>Telefone*</p>
                    <input
                      type="message"
                      placeholder="Telefone"
                      v-model="info.telefone"
                      @change="atualizarCadastroInfo.telefone_error = ''"
                    />
                    <p
                      v-if="atualizarCadastroInfo.telefone_error != ''"
                      class="error"
                    >
                      {{ atualizarCadastroInfo.telefone_error }}
                    </p>
                  </div>
                </div>
                <div class="duple-input">
                  <div class="unique-input">
                    <p>Senha*</p>
                    <input
                      type="password"
                      placeholder="Senha"
                      @change="atualizarCadastroInfo.senha_error = ''"
                      v-model="info.senha"
                    />
                    <p
                      v-if="atualizarCadastroInfo.senha_error != ''"
                      class="error"
                    >
                      {{ atualizarCadastroInfo.senha_error }}
                    </p>
                  </div>
                  <div class="unique-input">
                    <p>Repetir senha*</p>
                    <input
                      type="password"
                      placeholder="Repetir senha"
                      v-model="info.repetirsenha"
                      @change="atualizarCadastroInfo.repetirsenha_error = ''"
                    />
                    <p
                      v-if="atualizarCadastroInfo.repetirsenha_error != ''"
                      class="error"
                    >
                      {{ atualizarCadastroInfo.repetirsenha_error }}
                    </p>
                  </div>
                </div>
                <div class="duple-input">
                  <div class="unique-input">
                    <p>CPF*</p>
                    <input
                      type="text"
                      placeholder="CPF"
                      @change="atualizarCadastroInfo.cpf_error = ''"
                      v-model="info.cpf"
                    />
                    <p
                      v-if="atualizarCadastroInfo.cpf_error != ''"
                      class="error"
                    >
                      {{ atualizarCadastroInfo.cpf_error }}
                    </p>
                  </div>
                  <div class="unique-input">
                    <p>Data de Nascimento*</p>
                    <input
                      type="date"
                      placeholder="Data de Nascimento"
                      @change="
                        atualizarCadastroInfo.datadenascimento_error = ''
                      "
                      v-model="info.datadenascimento"
                    />
                    <p
                      v-if="atualizarCadastroInfo.datadenascimento_error != ''"
                      class="error"
                    >
                      {{ atualizarCadastroInfo.datadenascimento_error }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="btns-add-address-options">
                <div class="btn-add-address" @click="atualizarCadastro()">
                  <div class="btn-detail">
                    <p>Atualizar</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="cadastro_info" v-if="tela === 'CadastrarAddress'">
            <!-- <h3>Cadastrar Endereço</h3>
            <div id="cadastro_info_inputs">
              <the-mask
                :mask="['#####-###']"
                v-model="endereco.cep"
                placeholder="CEP"
              /><br />
              <input type="message" placeholder="Rua" v-model="endereco.rua" />
              <br />
              <input
                type="message"
                placeholder="Número"
                v-model="endereco.numero"
              />
              <br />
              <input
                type="message"
                placeholder="Complemento"
                v-model="endereco.complemento"
              />
              <br />
              <input
                type="message"
                placeholder="Bairro"
                v-model="endereco.bairro"
              />
              <br />
              <input
                type="message"
                placeholder="Cidade"
                v-model="endereco.cidade"
              />
              <br />
              <select v-model="endereco.estado">
                <option disable value>Escolha um estado</option>
                <option v-for="item in estados" :key="item" :value="item">
                  {{ item }}
                </option>
              </select>
            </div> -->
            <div class="address-new">
              <div class="input-address">
                <h2>Cadastrar endereço</h2>
                <div class="duple-input">
                  <div class="unique-input">
                    <p>Identificação de endereço*</p>
                    <input
                      @chang@changee="
                        enderecoCadastro.identificacaolocal_error = ''
                      "
                      v-model="enderecoCadastro.identificacaolocal"
                      placeholder="Minha casa, casa de mãe, ..."
                    />
                    <p
                      v-if="enderecoCadastro.identificacaolocal_error != ''"
                      class="error"
                    >
                      {{ enderecoCadastro.identificacaolocal_error }}
                    </p>
                  </div>
                </div>
                <div class="duple-input">
                  <div class="unique-input">
                    <p>CEP*</p>
                    <the-mask
                      :mask="['#####-###']"
                      v-model="enderecoCadastro.cep"
                      :masked="true"
                      placeholder="_____-___"
                      @change.native="
                        enderecoCadastro.cep_error = '';
                        getCEP();
                      "
                    />
                    <p v-if="enderecoCadastro.cep_error != ''" class="error">
                      {{ enderecoCadastro.cep_error }}
                    </p>
                  </div>
                </div>
                <div class="duple-input">
                  <div class="unique-input">
                    <p>Endereço*</p>
                    <input
                      @change="enderecoCadastro.endereco_error = ''"
                      v-model="enderecoCadastro.endereco"
                      placeholder="Rua, Avenida, Logradouro"
                    />
                    <p
                      v-if="enderecoCadastro.endereco_error != ''"
                      class="error"
                    >
                      {{ enderecoCadastro.endereco_error }}
                    </p>
                  </div>
                  <div class="down-input">
                    <div class="unique-input">
                      <p>Número*</p>
                      <input
                        placeholder=""
                        @change="enderecoCadastro.numero_error = ''"
                        v-model="enderecoCadastro.numero"
                      />
                      <p
                        v-if="enderecoCadastro.numero_error != ''"
                        class="error"
                      >
                        {{ enderecoCadastro.numero_error }}
                      </p>
                    </div>
                    <div class="unique-input">
                      <p>Complemento</p>
                      <input
                        @change="enderecoCadastro.complemento_error = ''"
                        v-model="enderecoCadastro.complemento"
                        placeholder="Ex.: Apt, Blc"
                      />
                      <p
                        v-if="enderecoCadastro.complemento_error != ''"
                        class="error"
                      >
                        {{ enderecoCadastro.complemento_error }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="duple-input">
                  <div class="unique-input">
                    <p>Bairro*</p>
                    <input
                      @change="enderecoCadastro.bairro_error = ''"
                      v-model="enderecoCadastro.bairro"
                      placeholder=""
                    />
                    <p v-if="enderecoCadastro.bairro_error != ''" class="error">
                      {{ enderecoCadastro.bairro_error }}
                    </p>
                  </div>
                  <div class="unique-input">
                    <p>Referência</p>
                    <input
                      v-model="enderecoCadastro.referencia"
                      @change="enderecoCadastro.referencia_error = ''"
                      placeholder="Ex.: Próximo ao shopping"
                    />
                    <p
                      v-if="enderecoCadastro.referencia_error != ''"
                      class="error"
                    >
                      {{ enderecoCadastro.referencia_error }}
                    </p>
                  </div>
                </div>
                <div class="duple-input">
                  <div class="unique-input disabled-input">
                    <p>Cidade*</p>
                    <input
                      @change="enderecoCadastro.cidade_error = ''"
                      disabled
                      v-model="enderecoCadastro.cidade"
                      placeholder=""
                    />
                    <p v-if="enderecoCadastro.cidade_error != ''" class="error">
                      {{ enderecoCadastro.cidade_error }}
                    </p>
                  </div>
                  <div class="unique-input disabled-input">
                    <p>Estado*</p>
                    <input
                      disabled
                      @change="enderecoCadastro.estado_error = ''"
                      v-model="enderecoCadastro.estado"
                      placeholder=""
                    />
                    <p v-if="enderecoCadastro.estado_error != ''" class="error">
                      {{ enderecoCadastro.estado_error }}
                    </p>
                  </div>
                </div>
                <div class="duple-input">
                  <div class="unique-input">
                    <p>Destinatário*</p>
                    <input
                      @change="enderecoCadastro.destinatario_error = ''"
                      v-model="enderecoCadastro.destinatario"
                      placeholder="Nome completo impresso na nota fiscal"
                    />
                    <p
                      v-if="enderecoCadastro.destinatario_error != ''"
                      class="error"
                    >
                      {{ enderecoCadastro.destinatario_error }}
                    </p>
                  </div>
                  <div class="unique-input">
                    <p>Telefone do destinatário*</p>
                    <the-mask
                      @change.native="
                        enderecoCadastro.telefone_destinatario_error = ''
                      "
                      :mask="['(##) #####-####', '(##) ####-####']"
                      v-model="enderecoCadastro.telefone_destinatario"
                      :masked="true"
                      placeholder="DDD + Número celular ou fixo do destinatário"
                    />
                    <p
                      v-if="enderecoCadastro.telefone_destinatario_error != ''"
                      class="error"
                    >
                      {{ enderecoCadastro.telefone_destinatario_error }}
                    </p>
                  </div>
                </div>
                <div class="btns-add-address-options">
                  <div class="btn-add-address" @click="createEndereco()">
                    <div class="btn-detail">
                      <p>Enviar para esse endereço</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- <p
              v-if="necessary"
              style="
                margin: 10px;
                color: red;
                font-weight: 700;
                font-size: 14px;
              "
            >
              Todos os campos são necessários!
            </p>
            <button type="button" id="btn_insert" v-on:click="createEndereco">
              Adicionar
            </button> -->
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import Enderecos from "../components/Enderecos";
import Pedidos from "../components/Pedidos";
import axios from "axios";
import { TheMask } from "vue-the-mask";
export default {
  name: "HomeProfile",
  components: {
    Enderecos,
    Pedidos,
    TheMask,
  },
  data() {
    return {
      info: {
        nome: "",
        sobrenome: "",
        email: "",
        telefone: "",
        senha: "",
        repetirsenha: "",
        cpf: "",
        datadenascimento: new Date(),
      },
      atualizarCadastroInfo: {
        nome_error: "",
        cpf_error: "",
        senha_error: "",
        repetirsenha_error: "",
        datadenascimento_error: "",
        sobrenome_error: "",
        telefone_error: "",
        email_error: "",
      },
      enderecoCadastro: {
        identificacaolocal: "",
        cep: "",
        endereco: "",
        numero: "",
        complemento: "",
        bairro: "",
        referencia: "",
        cidade: "",
        estado: "",
        destinatario: "",
        telefone_destinatario: "",
        // Casos de erros
        identificacaolocal_error: "",
        cep_error: "",
        endereco_error: "",
        numero_error: "",
        complemento_error: "",
        bairro_error: "",
        referencia_error: "",
        cidade_error: "",
        estado_error: "",
        destinatario_error: "",
        telefone_destinatario_error: "",
      },
      enderecos: [],
      estados: [
        "Acre",
        "Alagoas",
        "Amapá",
        "Amazonas",
        "Bahia",
        "Ceará",
        "Espírito Santo",
        "Goiás",
        "Maranhão",
        "Mato Grosso",
        "Mato Grosso do Sul",
        "Minas Gerais",
        "Pará",
        "Paraíba",
        "Paraná",
        "Pernambuco",
        "Piauí",
        "Rio de Janeiro",
        "Rio Grande do Norte",
        "Rio Grande do Sul",
        "Rondônia",
        "Roraima",
        "Santa Catarina",
        "São Paulo",
        "Sergipe",
        "Tocantins",
      ],
      infos: null,
      tela: "Pedidos",
      error_message: "",
      necessary: false,
      pedidos: [],
      endereco: {
        rua: "",
        numero: "",
        complemento: "",
        bairro: "",
        cidade: "",
        estado: "",
        pais: "Brasil",
        cep: "",
      },
    };
  },
  mounted() {
    let user = JSON.parse(localStorage.getItem("usuario"));
    if (!user) {
      this.$router.push("/login");
    }
    this.infos = user;
    try {
      this.getEnderecos(user);
      this.getPedidos(user);
    } catch (err) {
      if (err.error === "Token invalid") {
        localStorage.setItem("usuario", null);
        this.$router.push("/login");
      }
    }

    if (this.$route.query.g === "na") {
      this.seeView("CadastrarAddress");
    }
  },
  methods: {
    updateArray() {
      this.$forceUpdate();
    },
    seeView(visao) {
      if (visao === "Cadastro" && this.infos) {
        this.info = {
          nome: this.infos.cliente.nome,
          sobrenome: this.infos.cliente.sobrenome,
          email: this.infos.user.email,
          telefone: this.infos.cliente.telefone,
          senha: "",
          repetirsenha: "",
          cpf: "",
          datadenascimento: new Date(),
        };
      }
      this.tela = visao;
    },
    atualizarCadastro() {
      try {
        let error = false;
        if (!this.info.senha || this.info.senha == "") {
          error = true;
          this.atualizarCadastroInfo.senha_error = "Informe uma senha válida";
        }
        if (!this.info.repetirsenha || this.info.repetirsenha === "") {
          error = true;
          this.atualizarCadastroInfo.repetirsenha_error =
            "Informe uma senha válida";
        }
        if (!this.info.nome || this.info.nome == "") {
          error = true;
          this.atualizarCadastroInfo.nome_error = "Insira seu nome";
        }
        if (!this.info.sobrenome || this.info.sobrenome == "") {
          error = true;
          this.atualizarCadastroInfo.sobrenome_error = "Insira seu sobrenome";
        }
        if (!this.info.email || this.info.email == "") {
          error = true;
          this.atualizarCadastroInfo.email_error = "Insira um email válido";
        }
        if (!this.info.telefone || this.info.telefone == "") {
          error = true;
          this.atualizarCadastroInfo.telefone_error =
            "Insira seu telefone para contato";
        }
        if (!this.info.cpf || this.info.cpf == "") {
          error = true;
          this.atualizarCadastroInfo.cpf_error = "Insira seu CPF";
        }
        if (!this.info.datadenascimento || this.info.datadenascimento == "") {
          error = true;
          this.atualizarCadastroInfo.datadenascimento_error =
            "Insira sua data de nascimento";
        }

        if (this.info.senha != this.info.repetirsenha) {
          error = true;
          this.atualizarCadastroInfo.senha_error = "As senhas não correspondem";
          this.atualizarCadastroInfo.repetirsenha_error =
            "As senhas não correspondem";
        }

        if (this.info.telefone < 10) {
          error = true;
          this.atualizarCadastroInfo.telefone_error =
            "Insira o telefone com DDD";
        }

        if (
          this.yearsDiff(new Date().toString(), this.info.datadenascimento) < 18
        ) {
          error = true;
          this.atualizarCadastroInfo.datadenascimento_error =
            "É preciso ter mais de 18 anos";
        }

        if (!this.testaCPF(this.info.cpf)) {
          error = true;
          this.atualizarCadastroInfo.cpf_error = "CPF inválido";
        }

        if (!error) {
          // TO DO: make a request to update informations 

          alert("Atualizado")
          this.info = {
            nome: "",
            sobrenome: "",
            email: "",
            telefone: "",
            senha: "",
            repetirsenha: "",
            cpf: "",
            datadenascimento: new Date(),
          };
        }
      } catch (err) {
        alert("error");
      }
    },
    yearsDiff(d1, d2) {
      let date1 = new Date(d2);
      let date2 = new Date(d1);
      let yearsDiff = date2.getFullYear() - date1.getFullYear();
      return yearsDiff;
    },
    testaCPF(strCPF) {
      var Soma;
      var Resto;
      Soma = 0;
      if (strCPF == "00000000000") return false;

      for (let i = 1; i <= 9; i++)
        Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
      Resto = (Soma * 10) % 11;

      if (Resto == 10 || Resto == 11) Resto = 0;
      if (Resto != parseInt(strCPF.substring(9, 10))) return false;

      Soma = 0;
      for (let i = 1; i <= 10; i++)
        Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
      Resto = (Soma * 10) % 11;

      if (Resto == 10 || Resto == 11) Resto = 0;
      if (Resto != parseInt(strCPF.substring(10, 11))) return false;
      return true;
    },
    getEnderecos(user) {
      this.$http
        .get(`/projects/cliente/enderecos/${user.cliente._id}`)
        .then((res) => {
          let ende = res.data;
          let itens = [];

          for (let e = 0; e < ende.length; e += 2) {
            let inside = [];
            if (ende[e]) inside.push(ende[e]);
            if (ende[e + 1]) inside.push(ende[e + 1]);
            itens.push(inside);
          }
          this.enderecos = itens;
        })
        .catch((err) => {
          if (err.error == "Token invalid") {
            localStorage.setItem("usuario", null);
            this.$router.push("/login");
          }
        });
    },
    getPedidos(user) {
      this.$http
        .get(`/projects/vendas/detalhes/all/${user.user._id}`)
        .then((res) => {
          this.pedidos = res.data;
        });
    },
    createEndereco() {
      if (
        this.enderecoCadastro.identificacaolocal &&
        this.enderecoCadastro.cep &&
        this.enderecoCadastro.endereco &&
        this.enderecoCadastro.numero &&
        this.enderecoCadastro.bairro &&
        this.enderecoCadastro.cidade &&
        this.enderecoCadastro.estado &&
        this.enderecoCadastro.destinatario &&
        this.enderecoCadastro.telefone_destinatario
      ) {
        let user = JSON.parse(localStorage.getItem("usuario"));
        this.$http
          .post(`/projects/cliente/endereco/${user.cliente._id}`, {
            identificacao: this.enderecoCadastro.identificacaolocal,
            referencia: this.enderecoCadastro.referencia,
            rua: this.enderecoCadastro.endereco,
            numero: this.enderecoCadastro.numero,
            cidade: this.enderecoCadastro.cidade,
            complemento: this.enderecoCadastro.complemento,
            bairro: this.enderecoCadastro.bairro,
            estado: this.enderecoCadastro.estado,
            cep: this.enderecoCadastro.cep,
            destinatario: this.enderecoCadastro.destinatario,
            telefonedestinatario: this.enderecoCadastro.telefone_destinatario,
          })
          .then(() => {
            this.enderecoCadastro.identificacaolocal = "";
            this.enderecoCadastro.cep = "";
            this.enderecoCadastro.endereco = "";
            this.enderecoCadastro.numero = "";
            this.enderecoCadastro.bairro = "";
            this.enderecoCadastro.cidade = "";
            this.enderecoCadastro.estado = "";
            this.enderecoCadastro.destinatario = "";
            this.enderecoCadastro.telefone_destinatario = "";
            this.getEnderecos(user);
            this.tela = "Endereços";
            // if (this.$route.query.g === "na") this.$router.push(`/checkout`);
          })
          .catch((err) => {
            this.error_message = err.error;
          });
      } else {
        if (this.enderecoCadastro.identificacaolocal == "")
          this.enderecoCadastro.identificacaolocal_error = "Campo necessário";
        if (this.enderecoCadastro.cep == "")
          this.enderecoCadastro.cep_error = "Campo necessário";
        if (this.enderecoCadastro.endereco == "")
          this.enderecoCadastro.endereco_error = "Campo necessário";
        if (this.enderecoCadastro.numero == "")
          this.enderecoCadastro.numero_error = "Campo necessário";
        if (this.enderecoCadastro.bairro == "")
          this.enderecoCadastro.bairro_error = "Campo necessário";
        if (this.enderecoCadastro.cidade == "")
          this.enderecoCadastro.cidade_error = "Campo necessário";
        if (this.enderecoCadastro.estado == "")
          this.enderecoCadastro.estado_error = "Campo necessário";
        if (this.enderecoCadastro.destinatario == "")
          this.enderecoCadastro.destinatario_error = "Campo necessário";
        if (this.enderecoCadastro.telefone_destinatario == "")
          this.enderecoCadastro.telefone_destinatario_error =
            "Campo necessário";
        this.necessary = true;
      }
    },
    async getCEP() {
      await axios
        .get(`https://viacep.com.br/ws/${this.enderecoCadastro.cep}/json`)
        .then((res) => {
          let endereco_ = res.data;
          this.enderecoCadastro.endereco = endereco_.logradouro;
          this.enderecoCadastro.bairro = endereco_.bairro;
          this.enderecoCadastro.cidade = endereco_.localidade;
          this.enderecoCadastro.estado = endereco_.uf;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    logOut() {
      localStorage.setItem("usuario", null);
      this.$router.push("/");
    },
  },
};
</script>

<style>
#account {
  margin: 10px auto;
  width: 98%;
}

.address-new .select-address {
  text-align: left;
  color: #000;
  margin: 20px;
}

.checkout-complete
  .checkout-steps
  .division
  .select-address
  .item-address-saved {
  border: 2px solid #ccc;
  margin: 10px 0px;
  padding: 20px;
  border-radius: 10px;
  align-items: center;
}

.checkout-complete
  .checkout-steps
  .division
  .select-address
  .item-address-saved
  .item-address-saved-info {
  display: flex;
}

.checkout-complete
  .checkout-steps
  .division
  .select-address
  .item-address-saved
  .indentfy-item-address {
  margin-bottom: 10px;
}

.checkout-complete
  .checkout-steps
  .division
  .select-address
  .item-address-saved
  .radio-button {
  border: 1px solid #000;
  height: 30px;
  width: 30px;
  margin-right: 20px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.address-new .select-address select {
  border: 1px solid #000;
  padding: 10px;
}

.address-new .input-address select {
  border: 1px solid #000;
  padding: 10px;
  margin-left: 10px;
}

.address-new .input-address .duple-input {
  display: flex;
}

.address-new .input-address .date-separator {
  width: 10px;
}

.address-new .input-address .unique-input p {
  text-align: left;
  color: #000;
  margin-left: 10px;
  margin-top: 10px;
}

.address-new .input-address .unique-input {
  text-align: left;
  color: #000;
  margin-top: 10px;
}

.address-new .input-address .unique-input label {
  margin-left: 10px;
}

.address-new .input-address .unique-input input {
  border: 1px solid #000;
  padding: 10px;
  margin: 5px;
  margin-left: 10px;
}
.address-new .input-address .unique-input .error {
  color: red;
}

.address-new .input-address .disabled-input input {
  background-color: rgba(45, 45, 45, 0.3);
}

.address-new .btn-add-address {
  display: flex;
  justify-content: flex-end;
}

.address-new .btns-add-address-options {
  display: flex;
}

.address-new .btn-add-address .btn-detail {
  background-color: #5e984c;
  min-width: 200px;
  color: #fff;
  text-align: center;
  font-weight: bold;
  cursor: pointer;
  max-width: 300px;
  padding: 16px;
  border-radius: 5px;
  margin: 20px 0px;
}

.address-new .input-address .down-input {
  display: flex;
}

.address-new .input-address .duple-input .unique-input {
  margin-left: 10px;
}

#account h1 {
  margin-top: 20px;
  margin-bottom: 20px;
}

#sections_account {
  margin: 0 auto;
  /* width: 80%; */
}

#account_options {
  margin-bottom: 200px;

  display: inline-flex;
}

#account_options_names {
  border: 1px solid #eee;
  border-radius: 4px;
  width: 300px;
}

#account_options_names button {
  display: flex;
}

#account_options_names span {
  width: 25px;
  margin-left: 10px;
  margin-right: 10px;
}

.op1 button {
  display: flex;
  justify-items: center;
  align-items: center;
  border: none;
  padding: 10px;
  font-weight: lighter;
  color: #333;
}

.op1 button:hover {
  color: gainsboro;
}

.op1 button:focus {
  outline: none;
}

#options {
  text-align: left;
}

#cadastro_info {
  margin-bottom: 30px;
}

#cadastro_info_inputs {
  display: inline-table;
}

#cadastro_info h3 {
  margin-left: 10px;
  text-align: left;
}

#cadastro_info select {
  border: 1px solid #e4e4e4;
  width: 50%;
  padding: 10px;
  margin-top: 5px;
  margin-bottom: 5px;
  border-radius: 5px;
}

#btn_insert {
  border: none;
  background-color: #8d816b;
  color: #ffffff;
  font-weight: 600;
  width: 200px;
  border-radius: 3px;
  margin-top: 20px;
  margin-bottom: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
}

#sections_account #account_options #account_options_names .box {
  height: 100px;
  width: 100px;
  border-radius: 50%;
  background-color: black;
}

@media screen and (max-width: 800px) {
  #account_options {
    margin-bottom: 200px;
    display: inline-block;
  }

  #account_options_names {
    margin-bottom: 50px;
  }
}
</style>
